import byPageMaker from 'reducersMakers/byPageMaker';
import * as actions from 'actions';

export default byPageMaker([actions.SEARCH_RESULTS_RECEIVED], 'searchResultsIds');



/** WEBPACK FOOTER **
 ** ./src/members/state/search/results/byQuery/byPage/reducer.js
 **/